<template>
  <div id="meus-removidos">
    <my-tour v-if="itens.length > 0 || checkContent" :steps="steps" name="steps-leads-removidos"></my-tour>
    <section id="content">
      <!--start container-->
      <div class="container">
        <TituloPagina titulo="Gerenciamento de leads removidos"/>
        <div class="row">
          <div class="col s12" :class="classe">
            <div class="card-panel pt-0">
              <div class="row">
                <div class="col s12 m12 l12">
                  <h4 class="header2"></h4>
                  <div class="row pb-1">
                    <!--<div class="col s12 m6 l6">
                                            <h4 class="header2">Gerenciamento de leads removidos</h4>
                    </div>-->
                    <div class="col s12 l12">
                      <button
                        id="remove"
                        class="btn waves-effect waves-light right btn-default"
                        @click="downloadXLS"
                      >
                        <i class="material-icons left">file_download</i>
                        Exportar
                      </button>
                    </div>
                  </div>

                  <ContainerAlert :show="! checkContent" message="Carregando Leads removidos..."/>
                  <ContainerAlert
                    :show="checkContent && itens.length === 0"
                    message="Nenhum lead removido..."
                  />

                  <table class="bordered striped" v-if="checkContent && itens.length > 0">
                    <thead>
                      <tr>
                        <th class="colNome">Nome</th>
                        <th class="colProduto">Produto</th>
                        <th class="colEstado">Estado</th>
                        <th class="colResponsavel">Responsável</th>
                        <th class="colData">Data</th>
                        <th id="colAcoesRecup" class="colAcoes center">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in paginationConfig.itens"
                        v-bind:key="item.pedido_id"
                        v-if="item.pedido_historico.funcionario && item.cliente_has_produto.cliente"
                        :id="'item-'+item.pedido_id">
                        <td
                          class="colNome">
                          {{ item.cliente_has_produto.cliente.pessoa.pessoa_nome }}
                        </td>
                        <td class="colProduto">{{ item.cliente_has_produto.produto.produto_nome }}</td>
                        <td
                          class="colEstado">
                          {{ item.pedido_historico.pedido_estagio.pedido_estagio_nome }}
                        </td>
                        <td class="colResponsavel">
                          {{ item.pedido_historico.funcionario.pessoa.pessoa_nome}}
                        </td>
                        <td class="colData">{{ getData(item.data_criacao) }}</td>
                        <td id="colAcoes" class="colAcoes center">
                          <button
                            v-on:click="confirm(item.pedido_id, index)"
                            class="btn-flat waves-effect btn-floating btn-transparent"
                            v-tooltip.bottom="'Restaurar Lead'">
                            <i class="material-icons text-default">history</i>
                          </button>
                          <botao-remover
                            :identificador="item.pedido_id"
                            :url="'pedido/forcar-remover/'+item.pedido_id"
                            v-if="checaCargoUsuario([])"
                            v-tooltip.top="'Remover permanentemente'">
                          </botao-remover>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <Pagination
                    v-if="itens.length > 0"
                    :perPage="paginationConfig.perPage"
                    :qty="paginationConfig.qty"
                    :setCurrent="setCurrent"
                    :current="paginationConfig.current"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- INICIO FILTRO -->
          <div class="col s12 m4 l2 p2" v-if="showFiltro">
            <card title="Filtros" :showActions="showCardActionsFilter" @clearFilter="clearFilter">
              <template slot="content">
                <div class="row">
                  <div class="col s12">
                    <div class="row" id="filter1">
                      <div class="Search">
                        <div class="col s12">
                          <span class="Search__title grey-text">Por Lead:</span>
                        </div>
                        <div class="chip mt-3" v-for="func in getLeadsData">
                          {{func.pessoa_nome}}
                          <i
                            class="close material-icons"
                            @click="removeFilterLead(func.cliente_id)">
                            close
                          </i>
                        </div>
                        <div class="Search input-field col s12 input-search">
                          <i class="material-icons">person_outline</i>
                          <input
                            type="text"
                            @input="debounceLead"
                            class="autocomplete"
                            id="lead-input">
                          <i
                            @click="clearFieldLead()"
                            class="material-icons md-18 grey-text clear">
                            clear
                          </i>
                          <label for="nome" />
                        </div>
                      </div>
                    </div>
                    <ul class="collection">
                      <li
                        class="collection-item pl-0 pr-0"
                        style="display: flex;justify-content: space-between;"
                        v-bind:key="lead.pessoa_id"
                        v-for="lead in leads">
                        <span
                          class="title"
                          style="text-transform: capitalize; font-size: .9rem">
                          {{ lead.pessoa_nome.toLowerCase() }}
                        </span>
                        <div class="secondary-content">
                          <input
                            type="checkbox"
                            v-model="checkLeads"
                            :value="lead.cliente_id"
                            :id="'lead'+lead.cliente_id"
                            :data-name="lead.pessoa_nome.toLowerCase()">
                          <label :for="'lead'+lead.cliente_id" />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </template>
            </card>
          </div>
          <!-- FINAL FILTRO -->
        </div>
      </div>
      <!--end container-->
    </section>
  </div>
</template>
<style>
#meus-removidos table {
  text-transform: uppercase;
}

#meus-removidos .colId {
  width: 5%;
}

#meus-removidos .colNome {
  width: 30%;
}

#meus-removidos .colProduto {
  width: 15%;
}

#meus-removidos .colEstado {
  width: 15%;
}

#meus-removidos .colResponsavel {
  width: 15%;
}

#meus-removidos .colData {
  width: 10%;
}

#meus-removidos .colAcoes {
  width: 10%;
}
#meus-removidos .card-panel {
  min-height: calc(100vh - 300px);
}
@media screen and (max-width: 768px) {
  #meus-removidos .colId {
    width: 20%;
  }

  #meus-removidos .colNome {
    width: 60%;
  }

  #meus-removidos .colAcoes {
    width: 20%;
  }

  #meus-removidos .colProduto {
    display: none;
  }

  #meus-removidos .colEstado {
    display: none;
  }

  #meus-removidos .colResponsavel {
    display: none;
  }

  #meus-removidos .colData {
    display: none;
  }
}
</style>
<script>
import { get, post, api } from "@/helpers/api";
import Message from "@/helpers/message";
import moment from "moment";
import MaskedInput from "vue-masked-input";
import Datepicker from "vuejs-datepicker";
import MyTour from "@/components/common/MyTour.vue";
import ContainerAlert from "@/components/common/ContainerAlert/ContainerAlert";
import TituloPagina from "@/components/common/TituloPagina";
import {
  ESTAGIO_PROSPECCAO,
  ESTAGIO_CHAMADA_TELEFONICA,
  ESTAGIO_PRIMEIRA_VISITA,
  ESTAGIO_EFETIVADO,
  ESTAGIO_NEGATIVADO,
  ESTAGIO_SEGUNDA_VISITA,
  ESTAGIO_EM_ESPERA,
  ESTAGIO_PERDIDO
} from "@/constants/pedidoEstagio.js";
import BotaoRemover from "@/components/common/BotaoRemover";
import {
  DONO,
  GERENTE,
  CORRETOR,
  ESPECIALISTA,
  LIDER,
  MASTER,
  PARCEIRO
} from "@/constants/funcionarioCargo.js";
import Auth from "@/store/auth";
import swal from "sweetalert2";
import Pagination from "@/components/common/Pagination/Pagination";
import ListHelper from "@/helpers/list";
import Card from "@/components/common/Card/Card";
import TourHelper from "@/helpers/tour";
import _ from "lodash";
import { isMultiEmpresa } from "@/environment";
import modal from "@/helpers/wm-modal";

export default {
  components: {
    MaskedInput,
    Datepicker,
    MyTour,
    BotaoRemover,
    TituloPagina,
    Pagination,
    ContainerAlert,
    Card
  },
  data: () => ({
    paginationConfig: {
      perPage: 20,
      qty: 1,
      current: 1,
      itens: []
    },
    classe: "m10 l10",
    showFiltro: true,
    itens: [],
    itensDefault: [],
    responsaveis: [],
    leads: [],
    filtro: {
      dataInicio: "",
      dataFim: "",
      estados: [],
      produtos: [],
      lead: []
    },
    estadoItems: [],
    produtoItems: [],
    checkContent: false,
    checkLeads: [],
    leadsPesquisados: [],
    cargoDono: null,
    cargoGerente: null,
    cargoCorretor: null,
    cargoParceiro: null,
    showCardActionsFilter: true,
    usuarioLogadoCargo: null,
    steps: []
  }),
  created: function() {
    // verifica se pode acessar componente

    const cargosPermissoes = isMultiEmpresa ? [GERENTE, ESPECIALISTA] : [DONO];
    if (
      Auth.getCargoUsuario() !== MASTER &&
      cargosPermissoes.indexOf(Auth.getCargoUsuario()) === -1
    ) {
      this.$router.push("/sempermissao");
    }
    if (isMultiEmpresa) {
      this.showFiltro = false;
      this.classe = "m12 l12";
    }

    this.steps = TourHelper.createSteps(this.steps);
    this.usuarioLogadoCargo = Auth.getCargoUsuario();
    this.cargoDono = DONO;
    this.cargoGerente = GERENTE;
    this.cargoCorretor = CORRETOR;

    let self = this;
    self.showLoading();
    get("pedido/removidos").then(function(response) {
      self.itens = response.data.result.data;
      self.itensDefault = response.data.result.data;
      self.itens.forEach(function(value) {
        // console.log(value.pedido_historico.funcionario);

        value.show = true;

        let adicionar = true;
        self.estadoItems.forEach(function(item) {
          if (value.pedido_historico.pedido_estagio_id === item.estado_id) {
            adicionar = false;
          }
        });
        if (adicionar) {
          self.estadoItems.push({
            estado_id: value.pedido_historico.pedido_estagio_id,
            estado_nome:
              value.pedido_historico.pedido_estagio.pedido_estagio_nome
          });
        }

        let adicionarProduto = true;
        self.produtoItems.forEach(function(item) {
          if (value.cliente_has_produto.produto_id === item.produto_id) {
            adicionarProduto = false;
          }
        });
        if (adicionarProduto) {
          self.produtoItems.push({
            produto_id: value.cliente_has_produto.produto_id,
            produto_nome: value.cliente_has_produto.produto.produto_nome
          });
        }
      }, self);

      if (typeof self.$route.params.estagioId !== "undefined") {
        self.filtro.estados = [self.$route.params.estagioId];
        self.itens = self.itensDefault.filter(function(obj) {
          let incluiEstado = true;
          if (self.filtro.estados.length !== 0) {
            if (self.filtro.estados.indexOf("all") === -1) {
              incluiEstado = false;
              self.filtro.estados.forEach(function(estado) {
                if (obj.pedido_historico.pedido_estagio_id == estado) {
                  incluiEstado = true;
                }
              }, self);
            }
          }
          return incluiEstado;
        }, self);
      }

      if (!self.itens.length) {
        self.steps = [
          {
            parent: "#remove",
            target: "#remove",
            content: "Exporte a lista de Leads excluídos!",
            params: {
              cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
              placement: "left",
              bgTransparent: true,
              bgClass: "color-default",
              menu: false
            }
          },
          {
            parent: "#left-sidebar-nav",
            target: "#cadastro-cliente",
            content:
              "Para cadastrar um lead, basta no menu Cliente clicar em <b>Cadastro</b>!",
            params: {
              cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
              placement: "left",
              menu: true,
              route: "/cliente/cadastro",
              subMenu: true,
              subMenuTarget: "#group-cliente"
            }
          },

          {
            parent: "",
            target: "",
            content: "",
            params: {
              cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
              placement: "left",
              menu: false
            }
          }
        ];
        self.steps = TourHelper.createSteps(self.steps);
      } else {
        self.steps = [
          {
            parent: "#colAcoesRecup",
            target: "#colAcoesRecup",
            content:
              "Podemos recuperar o Lead, o que fará ele voltar para tela de <b>Gerenciamento de Leads</b>!",
            params: {
              cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
              placement: "left",
              menu: false
            }
          },
          {
            parent: "#remove",
            target: "#remove",
            content: "E exportar a lista de Leads excluídos!",
            params: {
              cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
              placement: "left",
              bgTransparent: true,
              bgClass: "color-default",
              menu: false
            }
          },
          {
            parent: "#left-sidebar-nav",
            target: "#cadastro-cliente",
            content:
              "Para cadastrar um lead, basta no menu Cliente clicar em <b>Cadastro</b>!",
            params: {
              cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
              placement: "left",
              menu: true,
              route: "/cliente/cadastro",
              subMenu: true,
              subMenuTarget: "#group-cliente"
            }
          },

          {
            parent: "",
            target: "",
            content: "",
            params: {
              cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
              placement: "left",
              menu: false
            }
          }
        ];
      }

      self.paginationConfig.qty = self.itens.length;
      self.paginationConfig.itens = ListHelper.getInterval(
        self.itens,
        self.paginationConfig.current,
        self.paginationConfig.perPage
      );

      self.hideLoading();
      self.checkContent = true;
    });
  },
  watch: {
    "paginationConfig.current"() {
      this.paginationConfig.itens = ListHelper.getInterval(
        this.itens,
        this.paginationConfig.current,
        this.paginationConfig.perPage
      );
    },
    checkLeads() {
      this.filtrar();
    },
    itens() {
      this.paginationConfig.qty = this.itens.length;
      this.paginationConfig.current = 1;
      this.paginationConfig.itens = ListHelper.getInterval(
        this.itens,
        1,
        this.paginationConfig.perPage
      );
    },
    "filtro.lead"() {
      this.leads = [];
      const leadsTemp = [];
      const self = this;
      if (this.filtro.lead) {
        get("cliente/busca/" + this.filtro.lead)
        .then(response => {
          let data = response.data.result.data;
          data.forEach(obj => {
            if (
              !leadsTemp.includes(obj.cliente_id) &&
              obj.pessoa_nome
                .toLowerCase()
                .includes(self.filtro.lead.toLowerCase())
            ) {
              self.leads.push({
                pessoa_nome: obj.pessoa_nome,
                pessoa_profissao: obj.pessoa_profissao,
                cliente_id: obj.cliente_id
              });
              self.leadsPesquisados.push({
                pessoa_nome: obj.pessoa_nome,
                pessoa_profissao: obj.pessoa_profissao,
                cliente_id: obj.cliente_id
              });
              leadsTemp.push(obj.cliente_id);
            }
          });
        });
      }
    }
  },
  computed: {
    getLeadsData() {
      if (!this.checkLeads.length) {
        return [];
      }
      return this.leadsPesquisados.filter(func =>
        this.checkLeads.some(checkFunc => checkFunc == func.cliente_id)
      );
    }
  },
  methods: {
    removeFilterLead(id) {
      this.checkLeads = this.checkLeads.filter(check => check != id);
    },
    clearFilter(e) {
      this.checkLeads = [];
      this.leadsPesquisados = [];
      $("#lead-input").val("");
    },
    debounceLead: _.debounce(function(e) {
      let time;
      clearTimeout(time);
      const self = this;
      time = setTimeout(function() {
        console.count();
        self.filtro.lead = e.target.value;
      }, 3000);
    }, 200),
    clearFieldLead() {
      this.filtro.lead = "";
      this.leads = [];
      $("#lead-input").val("");
    },
    setCurrent(current) {
      this.paginationConfig.current = current;
    },
    async confirm(id, index) {

        const result = await modal.confirm({
            text: "Tem certeza que restaurar esse registro?",
        });

        if (! result) return;

        await api.post("pedido/restaurar", { pedido_id: id });

        Message.messageSuccess("Lead restaurado com sucesso!");

        this.paginationConfig.itens.splice(index, 1);

    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    gerenciamentoLead(id) {
      this.$router.push("/lead-gerenciamento/" + id);
    },
    getData(data) {
      return moment(data).format("DD/MM/YYYY");
    },
    checkShowFiltro(item) {
      if (item.estado_id !== ESTAGIO_EM_ESPERA && item.estado_id !== ESTAGIO_PERDIDO) {
        return true;
      } else {
        return false;
      }
    },
    filtrar() {
      this.itens = this.itensDefault.filter(function(obj) {
        let incluiLead = true;
        if (this.checkLeads.length !== 0) {
          return this.checkLeads.includes(obj.cliente_has_produto.cliente_id);
        }
        return incluiLead;
      }, this);
      this.paginationConfig.current = -1;
      this.paginationConfig.current = 1;
    },
    showLoading() {
      this.$parent.$emit("showLoading", true);
    },
    hideLoading() {
      this.$parent.$emit("showLoading", false);
    },

    downloadXLS(args) {
      let self = this;
      let data, filename, link;
      let dataExport = [];

      self.itens.forEach(function(obj) {
        const {
          funcionario,
          pedido_estagio
        } = obj.pedido_historico;

        const {
          cliente,
          produto
        } = obj.cliente_has_produto

        dataExport.push({
          nome: !cliente ? '' : cliente.pessoa.pessoa_nome,
          produto: !produto ? '' : produto.produto_nome,
          estado: !pedido_estagio ? '' : pedido_estagio.pedido_estagio_nome,
          responsavel: !funcionario ? '' : funcionario.pessoa.pessoa_nome,
          data: self.getData(obj.data_criacao)
        });
      });

      let csv = this.convertArrayOfObjectsToCSV({
        data: dataExport
      });
      if (csv == null) return;

      filename = args.filename || "export.xls";

      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);

      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
    },
    convertArrayOfObjectsToCSV(args) {
      let result, ctr, keys, columnDelimiter, lineDelimiter, data;

      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }

      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";

      keys = Object.keys(data[0]);

      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;

      data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
          if (ctr > 0) result += columnDelimiter;

          result += item[key];
          ctr++;
        });
        result += lineDelimiter;
      });

      return result;
    },
    checaCargoUsuario(arrayPode) {
      if (this.usuarioLogadoCargo === MASTER) {
        return true;
      }
      return arrayPode.indexOf(this.usuarioLogadoCargo) !== -1;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/lead/ListagemRemovidos.vue